export default __webpack_public_path__ + "static/media/CSQ-8.d12576cd.pdf";